import React, { memo } from 'react';
import { AdminDateTimePickers } from '@/components/common/admin/shared/AdminDateTimePickers';

interface Props {
  DateTimePicker: any;
  datePickerState: any;
  onDateChange: (event: any, selectedDate?: Date) => void;
  onConfirm: (pickerType: 'start' | 'end' | 'publish') => void;
  onCancel: () => void;
  onModeChange: (mode: 'date' | 'time') => void;
  webAnchor?: any;
}

export const EventDateTimePickers: React.FC<Props> = memo(({ 
  DateTimePicker,
  datePickerState,
  onDateChange,
  onConfirm,
  onCancel,
  onModeChange,
  webAnchor,
}) => {
  return (
    <AdminDateTimePickers
      DateTimePicker={DateTimePicker}
      datePickerState={datePickerState}
      onDateChange={onDateChange}
      onConfirm={onConfirm}
      onCancel={onCancel}
      onModeChange={onModeChange}
      enabledPickers={{ start: true, end: true, publish: true }}
      titles={{ start: 'Start Time', end: 'End Time', publish: 'Publish Time' }}
      webAnchor={webAnchor}
    />
  );
});

EventDateTimePickers.displayName = 'EventDateTimePickers';


